/* eslint-disable import/no-anonymous-default-export*/
import {
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  REDIRECT,
  GET_ORDER,
  GET_ORDERS,
} from "../actions/types";

const initialState = {
  isLoading: true,
  orders: [],
  order: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ORDER_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        order: action.payload,
      };
    case GET_ORDER:
      return {
        ...state,
        order: action.payload,
      };
    case GET_ORDERS:
      return {
        ...state,
        orders: action.payload,
      };

    case ORDER_CREATE_FAIL:
      return {
        ...state,
        orders: null,
      };
    case REDIRECT:
      return {
        ...state,
        isLoading: true,
      };

    default:
      return state;
  }
}
